import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Teach tailwind-merge about the token-driven font-size utilities (text-label-caps, …) so they
// are not mistaken for text colors and dropped when merged with e.g. text-neutral-ink.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "label-caps",
            "label-caps-large",
            "body-emphasis",
            "body-nav-item",
            "body-small",
            "body-value",
            "body-value-large",
            "button-default",
            "display-stat-value",
            "heading-page-title",
            "heading-section-title",
            "heading-tab",
            "table-header",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Shared focus ring: visible on keyboard focus only, brand colored. */
export const focusRing =
  "outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface-card";
